/// <amd-module name="Traceability/RunView/WorkItems/RunViewWorkItemsService" />
import { Utilities } from "Traceability/Common/Utilities";
import { RunViewCommonService } from "Traceability/RunView/Common/RunViewCommonService";
import { IRunViewWorkItemsService } from "Traceability/RunView/WorkItems/RunViewWorkItemsService.types";
import { IArtifactDetails, WorkItemRef, WorkItemType, IDataResult } from "Traceability/WorkItems/Types";
import { WorkItemTypesUtility } from "Traceability/WorkItems/WorkItemTypesUtility";
import { IVssPageContext, Services } from "VSS/Platform/Context";

export class RunViewWorkItemsService extends RunViewCommonService<WorkItemRef> implements IRunViewWorkItemsService {
    protected get dataProviderId(): string {
        return this._runDataProviderId;
    }

    public get hubRouteId(): string {
        return this._hubRouteId;
    }

    public getWorkItems = (artifactDetails: IArtifactDetails): Promise<IDataResult<WorkItemRef>> => {
        return Utilities.getDataProviderDataAsync<IDataResult<WorkItemRef>>(this.contributionService, this._dataProviderId, artifactDetails);
    }

    public getWorkItemTypes(artifactDetails: IArtifactDetails): Promise<WorkItemType[]> {
        return WorkItemTypesUtility.getWorkItemTypes(this.pageContext, artifactDetails);
    }

    public _serviceStart(pageContext: IVssPageContext): void {
        super._serviceStart(pageContext);
    }

    public _serviceEnd(pageContext: IVssPageContext): void {
        super._serviceEnd(pageContext);
    }

    private _runDataProviderId = "ms.vss-traceability-web.traceability-run-workitems-data-provider";
    private _hubRouteId = "ms.vss-traceability-web.traceability-run-workitems-hub-default-route";
    private _dataProviderId = "ms.vss-traceability-web.traceability-workitems-data-provider";
}

Services.add("IRunViewWorkItemsService", { serviceFactory: RunViewWorkItemsService });